import {
  FilterItemSortingStrategy,
  RefinementItem,
} from "@/components/Search/types";

const getSortedRefinementItems = (
  refinementItems: RefinementItem[],
  sortStrategy: FilterItemSortingStrategy = "alphabetical",
): RefinementItem[] => {
  return refinementItems.sort((a, b) => {
    // Sort by `isRefined` first
    const isRefinedDiff = Number(b.isRefined) - Number(a.isRefined);
    if (isRefinedDiff !== 0) return isRefinedDiff;

    if (sortStrategy === "count") {
      return b.count - a.count;
    }

    return a.value.localeCompare(b.value);
  });
};

export default getSortedRefinementItems;
